import {AppInjector} from '../utils/app.injector';
import {Router} from '@angular/router';
import { AfterViewInit, Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import { ToastService } from '../services/toast.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    template: ''
})
export abstract class BaseComponent implements OnInit, OnDestroy, AfterViewInit {

    protected router: Router = AppInjector.get(Router);
    protected ngZone: NgZone = AppInjector.get(NgZone);
    protected spinner: NgxSpinnerService = AppInjector.get(NgxSpinnerService);
    protected notification: ToastService = AppInjector.get(ToastService);
    protected translateService: TranslateService = AppInjector.get(TranslateService);

    constructor() {}
    ngOnInit(): void {}
    ngOnDestroy(): void {}
    ngAfterViewInit(): void {}

    protected navigate(urls: any[]): void {
        this.ngZone.run(() => this.router.navigate(urls)).then();
    }

    protected applyMasks(): void {
        window.setTimeout(() => {
        }, 200);
    }

}
